export default "__VITE_ASSET__d9799aac__"